import { invalidateReadManifests } from '../../data/readCache';
import { useQueryClient, type QueryClient } from '@tanstack/react-query';

/**
 * Invalidates all availability-related queries.
 * Call this after any operation that affects inventory availability:
 * - Transfer orders created/updated/received
 * - Asset status changes
 * - Stock adjustments
 * - Event line date changes
 * - Event status/confirmation changes
 * - Physical fulfillment picks and returns
 */
export function invalidateAvailabilityQueries(queryClient: QueryClient) {
  invalidateReadManifests();
  void queryClient.invalidateQueries({ queryKey: ['inventory', 'itemSnapshots'] });
  void queryClient.invalidateQueries({ queryKey: ['inventory', 'productAvailability'] });
  void queryClient.invalidateQueries({ queryKey: ['events', 'availability'] });
}

/**
 * Hook that provides the invalidation function with query client already bound.
 */
export function useInvalidateAvailability() {
  const queryClient = useQueryClient();
  return () => invalidateAvailabilityQueries(queryClient);
}
